<template>
	<div class="solicitor-details">
		<div class="card-table rounded-bottom">
			<b-form role="form">
				<b-row>
					<b-col md="8" cols="12">
						<b-form-group label="Solicitor">
							<b-form-input v-model="form.solicitor" required></b-form-input>
						</b-form-group>
					</b-col>
					<!-- Product Type Dropdown -->
					<b-col md="8" cols="12">
						<b-form-group label="Product">
							<b-form-input v-model="form.product_type" required></b-form-input>
						</b-form-group>
					</b-col>
					<!-- Loan Amount Input -->
					<b-col md="8" cols="12" v-if="product.product_detail.prod_sol_type === 'Loan Agreement'">
						<b-form-group label="Loan Amount (RM)">
							<b-form-input type="number" v-model="form.prod_sol_loan_margin" required></b-form-input>
						</b-form-group>
					</b-col>

					<!-- SPA Amount Input -->
					<b-col md="8" cols="12" v-else>
						<b-form-group label="SPA Amount (RM)">
							<b-form-input type="number" v-model="form.prod_sol_spa_amount" required></b-form-input>
						</b-form-group>
					</b-col>

					<!-- Estimate Product Value Input -->
					<b-col md="8" cols="12">
						<b-form-group label="Estimated Product Value">
							<b-form-input type="number" v-model="form.prod_sol_estimate_total" required></b-form-input>
						</b-form-group>
					</b-col>

					<b-col md="8" cols="12">
						<b-form-group label="Payment Mode">
							<el-select v-model="form.payment_mode" placeholder="Select">
								<el-option v-for="(item, index) in paymentOptions" :key="index" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</b-form-group>
					</b-col>

					<b-col md="8" cols="12">
						<b-form-group label="Solicitor Status Date">
							<b-form-input v-model="form.prod_sol_status_date" type="date"></b-form-input>
						</b-form-group>
					</b-col>

					<!-- Solicitor Sub Status Dropdown -->
					<b-col md="8" cols="12">
						<b-form-group label="Solicitor Sub Status">
							<el-select v-model="form.prod_sol_status" placeholder="Select">
								<el-option v-for="(item, index) in subSolicitorStatusOptions" :key="index" :label="item.status"
									:value="item.status"></el-option>
							</el-select>
						</b-form-group>
					</b-col>
					<b-col md="8" cols="12" v-if="product.product_detail.prod_sol_type === 'Loan Agreement'">
						<b-form-group label="LA Tracking Status Date">
							<b-form-input v-model="form.prod_sol_la_status_date" type="date"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col md="8" cols="12" v-else>
						<b-form-group label="SPA Tracking Status Date">
							<b-form-input v-model="form.prod_sol_spa_status_date" type="date"></b-form-input>
						</b-form-group>
					</b-col>
					<!-- LA Tracking Sub Status Dropdown -->
					<b-col md="8" cols="12" v-if="product.product_detail.prod_sol_type === 'Loan Agreement'">
						<b-form-group label="LA Tracking Sub Status">
							<el-select v-model="form.prod_sol_la_status" placeholder="Select">
								<el-option v-for="(item, index) in subLaStatusOptions" :key="index" :label="item.status"
									:value="item.status"></el-option>
							</el-select>
						</b-form-group>
					</b-col>

					<b-col md="8" cols="12" v-else>
						<b-form-group label="SPA Tracking Sub Status">
							<el-select v-model="form.prod_sol_spa_status" placeholder="Select">
								<el-option v-for="(item, index) in subSpaStatusOptions" :key="index" :label="item.status"
									:value="item.status"></el-option>
							</el-select>
						</b-form-group>
					</b-col>

					<b-col md="8" cols="12">
						<el-button class="bg-primary text-white" :loading="is_loading" @click="updateSolicitor">Save</el-button>
					</b-col>
				</b-row>
			</b-form>
		</div>
	</div>
</template>
<script>
import { Select, Option, RadioGroup, RadioButton, Button } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import {
	notifyFunctionMixin,
	helperFunctionMixin,
	axios,
	services,
	getHeader,
	debounce
} from '@/assets/js/httpImports.js'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
import { mapActions, mapState } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import { useProductStore } from '@/stores/productStore'
import { useLookupStore } from '@/stores/lookupStore'
export default {
	props: ['product'],
	mixins: [notifyFunctionMixin, helperFunctionMixin],
	components: {
		CurrencyInput,
		[Select.name]: Select,
		[Option.name]: Option,
		[RadioGroup.name]: RadioGroup,
		[RadioButton.name]: RadioButton,
		[Button.name]: Button,
	},
	data() {
		return {
			prodSSADetails: null,
			status: [],
			is_loading: false,
			form: {
				solicitor: '',
				product_type: '',
				prod_sol_loan_margin: null,
				prod_sol_spa_amount: null,
				prod_sol_estimate_total: null,
				payment_mode: '',
				prod_sol_status: '',
				prod_sol_status_date: '',
				prod_sol_la_status: '',
				prod_sol_la_status_date: '',
				prod_sol_spa_status: '',
				prod_sol_spa_status_date: ''
			},
			productOptions: [
				{ text: 'Buyer SPA', value: 'Buyer SPA' },
				{ text: 'Vendor SPA', value: 'Vendor SPA' },
				{ text: 'Loan Agreement', value: 'Loan Agreement' }
			],
			subLaStatusOptions: [],
			subSpaStatusOptions: [],
			subSolicitorStatusOptions: [],
			paymentOptions: [
				{
					value: 'Credit Card - Auto Debit',
					label: 'Credit Card - Auto Debit'
				},
				{
					value: 'Bank Transfer',
					label: 'Bank Transfer'
				},
				{
					value: 'Cheques',
					label: 'Cheques'
				},
				{
					value: 'Cash',
					label: 'Cash'
				},
				{
					value: 'Payment Getaway',
					label: 'Payment Getaway'
				},
				{
					value: 'Debit Card - Auto Debit',
					label: 'Debit Card - Auto Debit'
				},
				{
					value: 'Not Applicable',
					label: 'Not Applicable'
				},
				{
					value: 'Bank - Standing Instruction',
					label: 'Bank - Standing Instruction'
				},
			],
			solicitorOptions: [
				{ text: 'Gan & Zul', value: 'Gan & Zul' }
			],
		}
	},
	watch: {
		product: {
			handler(newVal) {
				this.form.solicitor = newVal.product_detail.prod_sol_firm || '';
				this.form.product_type = newVal.product_detail.prod_sol_type || '';
				this.form.prod_sol_loan_margin = newVal.product_detail.prod_sol_loan_margin || '';
				this.form.prod_sol_spa_amount = newVal.product_detail.prod_sol_spa_amount || '';
				this.form.prod_sol_estimate_total = newVal.product_detail.prod_sol_estimate_total || '';
				this.form.payment_mode = newVal.product_detail.prod_sol_payment_mode || '';
				this.form.prod_sol_status_date = newVal.product_detail.prod_sol_status_date || '';
				this.form.prod_sol_status = newVal.prod_status || '';
				this.form.prod_sol_la_status_date = newVal.product_detail.prod_sol_la_status_date || ''; // Set default if undefined
				this.form.prod_sol_la_status = newVal.product_detail.prod_sol_la_sub_status || ''; // Set default if undefined
				this.form.prod_sol_spa_status_date = newVal.product_detail.prod_sol_spa_status_date || ''; // Set default if undefined
				this.form.prod_sol_spa_status = newVal.product_detail.prod_sol_spa_sub_status || ''; // Set default if undefined
			},
			immediate: true
		},
	},
	computed: {
		...mapState(useAuthStore, ['auth_user']),
		...mapState(useLookupStore, ['getLaStatus', 'getSpaStatus'])
	},
	mounted() {
		this.fetchLaSubStatusOptions();
		this.fetchSpaSubStatusOptions();
		this.fetchSolicitorStatus();
	},
	methods: {
		...mapActions(useProductStore, ['getCaseStatusList']),
		fetchSolicitorStatus() {
			const corporate_id = this.product.product_detail.prod_sol_firm_id
			this.getCaseStatusList('status-solicitor',{ corporate_id: corporate_id },'no_paginate').then(resp => {
				const allStatus = _gHlp.getValue(resp,'data');
				this.subSolicitorStatusOptions = allStatus.filter((item) => item.group === 'sub')
			});
		},
		async fetchLaSubStatusOptions() {
			const corporate_id = this.product.product_detail.prod_sol_firm_id
			try {
				const statuses = await this.getLaStatus(corporate_id); // Assuming this returns an array of statuses
				this.subLaStatusOptions = statuses
					.filter(status => status.group === 'sub') // Filter by group
					.map(status => ({
						status_id: status.la_status_id,
						status: status.status
					})); // Map to the required format
			} catch (e) {
				this.errorFunction(e);
			}
		},
		async fetchLaSubStatusOptions() {
			const corporate_id = this.product.product_detail.prod_sol_firm_id
			try {
				const statuses = await this.getLaStatus(corporate_id); // Assuming this returns an array of statuses
				this.subLaStatusOptions = statuses
					.filter(status => status.group === 'sub') // Filter by group
					.map(status => ({
						status_id: status.la_status_id,
						status: status.status
					})); // Map to the required format
			} catch (e) {
				this.errorFunction(e);
			}
		},
		async fetchSpaSubStatusOptions() {
			const corporate_id = this.product.product_detail.prod_sol_firm_id
			try {
				const statuses = await this.getSpaStatus(corporate_id); // Assuming this returns an array of statuses
				this.subSpaStatusOptions = statuses
					.filter(status => status.group === 'sub') // Filter by group
					.map(status => ({
						status_id: status.spa_status_id,
						status: status.status
					})); // Map to the required format
			} catch (e) {
				this.errorFunction(e);
			}
		},
		async updateSolicitor() {
			const status = this.subSolicitorStatusOptions.find((item) => item.status === this.form.prod_sol_status)
			// let acceptance_date = (this.form.acceptance_date) ? this.form.acceptance_date + " 00:00:00" : null;
			if (!status || !status.parent) {
				this.errorFunction(null, 'Status could not be found.')
				return
			}
			try {
				const solicitor = {
					prod_customer_id: this.product.prod_customer_id,
					prod_customer_name: this.product.prod_customer_name,
					prod_type: this.product.prod_type,
					prod_customer_basket: this.product.prod_customer_basket,
					prod_status: this.product.prod_status,
					prod_agent_id: this.product.prod_agent_id,
					prod_agent_username: this.product.prod_agent_username,
					prod_main_status: status.parent.status,
					prod_status: status.status,
					product_detail: {
						prod_sol_status_date: this.form.prod_sol_status_date,
						prod_sol_sub_status: this.form.prod_sol_status,
						prod_sol_payment_mode: this.form.payment_mode,
						prod_sol_la_sub_status: this.form.prod_sol_la_status,
						prod_sol_spa_sub_status: this.form.prod_sol_spa_status,
						prod_sol_spa_status_date: this.form.prod_sol_spa_status_date,
						prod_sol_la_status_date: this.form.prod_sol_la_status_date,
					}
				}
				this.is_loading = true
				axios.post(services.product + 'product/' + this.product.prod_id, solicitor, { headers: getHeader() })
				// .then(res => {
				this.is_loading = false
				caseEventBus.$emit('refresh-cases')
				this.notifySuccess('<b>Solicitor Case</b> - Successfully Updated.')
			} catch (e) {
				// })
				// .catch(e => {
				this.is_loading = false
				this.errorFunction(e)
				// })
			}
		}
	}
}
</script>